import { render } from "./TypesTable.vue?vue&type=template&id=767005b2"
import script from "./TypesTable.vue?vue&type=script&lang=js"
export * from "./TypesTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__